import { render, staticRenderFns } from "./AlocarLotesCheckbox.vue?vue&type=template&id=1c6bb553&scoped=true&"
import script from "./AlocarLotesCheckbox.vue?vue&type=script&lang=js&"
export * from "./AlocarLotesCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AlocarLotesCheckbox.vue?vue&type=style&index=0&id=1c6bb553&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bb553",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VIcon,VRow,VSpacer})
